export const convertToCommaSeparatedKeycodeUtil = (inputText) => {
  const commaSeparated = inputText
    .replace(/[a-zA-Z]/g, '')       // Remove any alphabets
    .replace(/[\r\n,\s]+/g, ',')    // Replace newlines, commas, and spaces with single comma
    .replace(/^,|,$/g, '')          // Remove leading/trailing commas
    .replace(/[^\d,]/g, '')         // Remove any remaining non-digit characters except commas

  const arrOfKeycodes = commaSeparated
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length > 0)
    .map(item => parseInt(item, 10))
    .filter(item => !isNaN(item))

  return arrOfKeycodes
}

export const convertToCommaSeparatedApnUtil = (inputText) => {
  const commaSeparated = inputText
    .replace(/[a-zA-Z]/g, '')       // Remove any alphabets
    .replace(/[\r\n,\s]+/g, ',')    // Replace newlines, commas, and spaces with single comma
    .replace(/^,|,$/g, '')          // Remove leading/trailing commas
    .replace(/[^\d,]/g, '')         // Remove any remaining non-digit characters except commas

  const arrOfApns = commaSeparated
    .split(',')
    .map(item => item.trim())
    .filter(item => item.length === 13)  // APNs must be 13 digits
    .map(item => parseInt(item, 10))
    .filter(item => !isNaN(item))

  return arrOfApns
}

const stringToColor = (string) => {
  let hash = 0
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }
  return color
}

export const generateAvatarProps = (name) => {
  if (!name) return {}
  return {
    sx: {
      bgcolor: stringToColor(name)
    },
    children: name[0].toUpperCase()
  }
}
